import type React from 'react'

interface ProfileIconProps {
  size?: number | string
  color?: string
  className?: string
}

const ProfileIcon: React.FC<ProfileIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Profile Icon'}
      role="img"
    >
      <path
        d="M16.25 7C16.25 4.65279 14.3472 2.75 12 2.75C9.65279 2.75 7.75 4.65279 7.75 7C7.75 9.34721 9.65279 11.25 12 11.25C14.3472 11.25 16.25 9.34721 16.25 7ZM17.75 7C17.75 10.1756 15.1756 12.75 12 12.75C8.82436 12.75 6.25 10.1756 6.25 7C6.25 3.82436 8.82436 1.25 12 1.25C15.1756 1.25 17.75 3.82436 17.75 7Z"
        fill={color}
      />
      <path
        opacity="0.4"
        d="M19.8398 22C19.8398 18.6809 16.4771 15.75 12 15.75C7.52295 15.7501 4.16016 18.6809 4.16016 22C4.16016 22.4142 3.82437 22.75 3.41016 22.75C2.99594 22.75 2.66016 22.4142 2.66016 22C2.66016 17.5792 6.99719 14.2501 12 14.25C17.0029 14.25 21.3398 17.5791 21.3398 22C21.3398 22.4142 21.0041 22.75 20.5898 22.75C20.1758 22.7498 19.8398 22.4141 19.8398 22Z"
        fill={color}
      />
    </svg>
  )
}

export default ProfileIcon
